"use client";
import type { FC } from "react";
import { createElement } from "react";
import { ModuleNotFound } from "@lib/contentful/modules-renderer/ModuleNotFound";
import type {
    MappedPageModule,
    PageModule,
    RawPageModule,
} from "@lib/contentful/mappers/modules/types";

export type ModuleProps = (MappedPageModule["model"] | { module: RawPageModule }) & {
    index: number;
};

export type ModuleComponent = FC<ModuleProps>;

interface IModuleCreatorProps {
    module: PageModule;
    index: number;
    type: string;
    component: ModuleComponent | undefined;
}

export const ModuleCreator: FC<IModuleCreatorProps> = ({
    module,
    index,
    type,
    component,
    ...rest
}) => {
    if (typeof component === "undefined") {
        return <ModuleNotFound type={type} />;
    }

    const moduleProps = "model" in module ? module.model : { module };
    return createElement(component, { ...moduleProps, index, ...rest });
};
